import apiClient from './client';
import type { PaginatedResponse } from '@/types/api';
import type { Visit, VisitFormData, VisitFilters, BulkAjutoareFormData, BulkAjutoareResponse } from '@/types/visit';

export async function getVisits(params?: VisitFilters): Promise<PaginatedResponse<Visit>> {
  const response = await apiClient.get<PaginatedResponse<Visit>>('/visits/', { params });
  return response.data;
}

export async function getVisit(id: string): Promise<Visit> {
  const response = await apiClient.get<{ data: Visit }>(`/visits/${id}`);
  return response.data.data;
}

export async function createVisit(data: VisitFormData): Promise<Visit> {
  const response = await apiClient.post<{ data: Visit }>('/visits/', data);
  return response.data.data;
}

export async function updateVisit(id: string, data: Partial<VisitFormData>): Promise<Visit> {
  const response = await apiClient.put<{ data: Visit }>(`/visits/${id}`, data);
  return response.data.data;
}

export async function deleteVisit(id: string): Promise<void> {
  await apiClient.delete(`/visits/${id}`);
}

export async function bulkCreateAjutoare(data: BulkAjutoareFormData): Promise<BulkAjutoareResponse> {
  const response = await apiClient.post<BulkAjutoareResponse>('/visits/bulk', data);
  return response.data;
}
